import React, { useState } from 'react';
import './AddSubunitDialog.css';

const AddSubunitDialog = ({ onClose, onAdd, adminUnitName }) => {
  const [formData, setFormData] = useState({
    name: '',
    nameEn: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim() || !formData.nameEn.trim()) {
      setError('Both name and English name are required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await onAdd(formData);
      setFormData({ name: '', nameEn: '' });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <div className="dialog-overlay" onClick={handleClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>Add New Subunit to {adminUnitName}</h3>
          <button 
            className="close-button" 
            onClick={handleClose}
            disabled={loading}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="dialog-form">
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="name">Subunit Name (Bengali) *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter subunit name in Bengali"
              required
              disabled={loading}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="nameEn">Subunit Name (English) *</label>
            <input
              type="text"
              id="nameEn"
              name="nameEn"
              value={formData.nameEn}
              onChange={handleInputChange}
              placeholder="Enter subunit name in English"
              required
              disabled={loading}
              className="form-input"
            />
          </div>

          <div className="dialog-actions">
            <button
              type="button"
              onClick={handleClose}
              className="cancel-button"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="submit-button"
              disabled={loading || !formData.name.trim() || !formData.nameEn.trim()}
            >
              {loading ? 'Adding...' : 'Add Subunit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSubunitDialog;
